import React from "react";
import Pill from "carbon-react/lib/components/pill";
import {
  agentStatuses,
  psuedoAgentStatusInvitePending,
  isAgentInvite,
} from "../../constants/model";

const AgentStatusPill = ({ agent }) => {
  return (
    <>
      {agent && isAgentInvite(agent) ? (
        <Pill pillRole="status" colorVariant="neutral" fill>
          {psuedoAgentStatusInvitePending.displayValue}
        </Pill>
      ) : agent && agent.status === agentStatuses.deactivated.value ? (
        <Pill pillRole="status" colorVariant="negative" fill>
          {agentStatuses.deactivated.displayValue}
        </Pill>
      ) : agent && agent.status === agentStatuses.active.value ? (
        <Pill pillRole="status" colorVariant="positive" fill>
          {agentStatuses.active.displayValue}
        </Pill>
      ) : null}
    </>
  );
};

export default AgentStatusPill;
